import { render, staticRenderFns } from "./vipTravel.vue?vue&type=template&id=534dd766&scoped=true&"
import script from "./vipTravel.vue?vue&type=script&lang=js&"
export * from "./vipTravel.vue?vue&type=script&lang=js&"
import style0 from "./vipTravel.vue?vue&type=style&index=0&id=534dd766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534dd766",
  null
  
)

export default component.exports